import { useEffect, useMemo, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { modules } from '../lib/modules';
import { Icon } from './Icon';

export function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const [online, setOnline] = useState(navigator.onLine);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => { window.removeEventListener('online', update); window.removeEventListener('offline', update); };
  }, []);
  useEffect(() => setMobileOpen(false), [location.pathname]);

  const title = useMemo(() => {
    if (location.pathname === '/') return 'Centro de comando';
    if (location.pathname === '/atlas') return 'Atlas — laboratório offline';
    if (location.pathname === '/fiscalidade') return 'Fiscalidade AO';
    if (location.pathname === '/settings') return 'Configuração';
    return modules.find((item) => location.pathname.includes(item.id))?.name || 'Nexo Angola';
  }, [location.pathname]);

  const nav = (
    <>
      <div className="brand">
        <div className="brand-mark"><Icon name="Atom" size={22} /></div>
        {!collapsed && <div><strong>Nexo</strong><span>ANGOLA</span></div>}
      </div>
      <nav className="main-nav" aria-label="Navegação principal">
        <NavLink to="/" end><Icon name="LayoutDashboard" /><span>Visão geral</span></NavLink>
        <NavLink to="/atlas"><Icon name="Network" /><span>Atlas offline</span><i>LOCAL</i></NavLink>
        <div className="nav-label">{!collapsed && 'INTELIGÊNCIA OPERACIONAL'}</div>
        {modules.map((item) => (
          <NavLink key={item.id} to={`/apps/${item.id}`} title={item.name}>
            <Icon name={item.icon} /><span>{item.shortName}</span>
          </NavLink>
        ))}
        <div className="nav-label">{!collapsed && 'CENTRO ESPECIALIZADO'}</div>
        <NavLink to="/fiscalidade"><Icon name="Calculator" /><span>Fiscalidade AO</span><i>NOVO</i></NavLink>
      </nav>
      <div className="sidebar-foot">
        <NavLink to="/settings"><Icon name="Settings" /><span>Configuração</span></NavLink>
        <button className="collapse-button" onClick={() => setCollapsed((value) => !value)} aria-label="Alternar barra lateral">
          <Icon name={collapsed ? 'PanelLeftOpen' : 'PanelLeftClose'} />
          {!collapsed && <span>Recolher</span>}
        </button>
      </div>
    </>
  );

  return (
    <div className={`app-shell ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <aside className="sidebar">{nav}</aside>
      {mobileOpen && <div className="mobile-drawer"><button onClick={() => setMobileOpen(false)}><Icon name="X" /></button>{nav}</div>}
      <main className="main-area">
        <header className="topbar">
          <button className="mobile-menu" onClick={() => setMobileOpen(true)} aria-label="Abrir menu"><Icon name="Menu" /></button>
          <div><span className="eyebrow">NEXO ANGOLA / OPERATIONS OS</span><h1>{title}</h1></div>
          <div className={`connection-pill ${online ? 'online' : 'offline'}`}>
            <Icon name={online ? 'Wifi' : 'WifiOff'} size={15} />
            {online ? 'Online' : 'Modo offline'}
          </div>
        </header>
        <div className="page"><Outlet /></div>
      </main>
    </div>
  );
}
